import { Navigate } from "react-router-dom";
import { useAuthRoles } from "../hooks/useAuthRoles";

export function RoleBasedRoute({ allowedRoles, children, adminOnly = false }) {
  const { decoded, isAdmin } = useAuthRoles();

  const realmRoles = decoded?.realm_access?.roles || [];
  const managementRoles =
    decoded?.resource_access?.["realm-management"]?.roles || [];
  const effectiveIsAdmin =
    typeof isAdmin === "boolean"
      ? isAdmin
      : realmRoles.includes("admin") ||
        realmRoles.includes("administrator") ||
        (managementRoles.includes("view-realm") &&
          managementRoles.includes("manage-users"));

  const effectiveRoles = [...realmRoles];
  if (effectiveIsAdmin) {
    effectiveRoles.push("admin");
  }

  const hasAccess = allowedRoles.some((role) => effectiveRoles.includes(role));

  if (adminOnly && !effectiveIsAdmin) {
    return <Navigate to="/unauthorized" replace />;
  }

  return hasAccess ? children : <Navigate to="/unauthorized" replace />;
}
